import { render } from "./BuyerOneColumnLot.vue?vue&type=template&id=1031af69&scoped=true"
import script from "./BuyerOneColumnLot.vue?vue&type=script&lang=js"
export * from "./BuyerOneColumnLot.vue?vue&type=script&lang=js"

import "./BuyerOneColumnLot.vue?vue&type=style&index=0&id=1031af69&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1031af69"]])

export default __exports__